// src/components/Navbar.js
import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import logo from '../imgs/SolyLuna.jpg'




function Navbar() {
    const [anchorElNav, setAnchorElNav] = useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const theme = useTheme();

    // < 1200px (xs–lg-1) → hamburguesa
    const isBelow1200 = useMediaQuery(theme.breakpoints.down('lg'));

    // 1200–1600px → menú normal + SUM corrido
    const isBetween1200And1600 = useMediaQuery('(min-width:1200px) and (max-width:1600px)');

    const titleLeft = isBetween1200And1600 ? '17%' : '50%';


    // Puedes manejar la lógica de autenticación aquí o en un hook de contexto
    const apiBaseUrl = 'https://api.edificiosolyluna.uy';
    const userRole = 'user'; // Simula el rol del usuario
    const { isAuthenticated, logout, isAdmin, mustChangedPassword } = useAuth(); // Destructure isAuthenticated and logout from useAuth

    if (isAuthenticated && mustChangedPassword) {
        return (
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box component="img" src={logo} alt="Logo" sx={{ width: 100, height: 80 }} />
                    </Box>

                    <Box sx={{
                        position: 'absolute',
                        left: titleLeft,                  // 👈 cambia según el ancho
                        transform: 'translateX(-50%)',
                        top: '50%',
                        transformOrigin: 'center',
                        pointerEvents: 'none',            // para que no bloquee clicks en otros lados
                    }}>
                        <Typography
                            variant="h4"
                            noWrap
                            component={Link}
                            to="/"
                            sx={{
                                fontFamily: 'monospace',
                                fontWeight: 1000,
                                letterSpacing: '.1rem',
                                color: '#dca652',
                                textDecoration: 'none',
                            }}
                        >
                            S.U.M.
                        </Typography>
                    </Box>

                    <Box>
                        <Button color="inherit" onClick={logout}>Cerrar Sesión</Button>
                    </Box>
                </Toolbar>
            </AppBar >
        );
    }
    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* IZQUIERDA: Imagen */}
                <Box
                    component={Link}
                    to="/"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                    }}
                >
                    <Box
                        component="img"
                        src={logo}
                        alt="Logo"
                        sx={{ width: 100, height: 80 }}
                    />
                </Box>

                {/* CENTRO: Título siempre centrado */}
                <Box sx={{
                    position: 'absolute',
                    left: titleLeft,                  // 👈 cambia según el ancho
                    transform: "translate(-50%, -50%)",   // 👈 centra vertical y horizontal
                    top: '50%',
                    transformOrigin: 'center',
                    pointerEvents: 'none',            // para que no bloquee clicks en otros lados
                }}>
                    <Typography
                        variant="h4"
                        noWrap
                        component={Link}
                        to="/"
                        sx={{
                            fontFamily: 'monospace',
                            fontWeight: 1000,
                            letterSpacing: '.1rem',
                            color: '#dca652',
                            textDecoration: 'none',
                            pointerEvents: 'auto',          // el link SÍ es clickeable

                        }}
                    >
                        S.U.M.
                    </Typography>
                </Box>

                {/* DERECHA: Botones o menú hamburguesa */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {/* Menú Hamburguesa en mobile */}
                    <Box sx={{ display: { xs: 'flex', lg: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="menu"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            keepMounted
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', lg: 'none' } }}
                        >
                            {isAuthenticated && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/novedades">
                                    <Typography textAlign="center">Novedades</Typography>
                                </MenuItem>
                            )}
                            {isAuthenticated && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/calendar">
                                    <Typography textAlign="center">Calendario</Typography>
                                </MenuItem>
                            )}
                            {isAdmin && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/reservas">
                                    <Typography textAlign="center">Reservas</Typography>
                                </MenuItem>
                            )}

                            {isAuthenticated && !isAdmin && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/profile">
                                    <Typography textAlign="center">Mis reservas</Typography>
                                </MenuItem>
                            )}
                            {isAdmin && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/admin">
                                    <Typography textAlign="center">Gestion</Typography>
                                </MenuItem>
                            )}

                            {/* {isAuthenticated && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/services">
                                <Typography textAlign="center">Servicios</Typography>
                                </MenuItem>
                            )} */}



                            {isAuthenticated && (

                                <MenuItem
                                    component="a"
                                    href={`${apiBaseUrl}/docs/Reglamento.pdf?cacheBuster=${new Date().getTime()}`}

                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={handleCloseNavMenu}
                                >
                                    <Typography textAlign="center">Reglamento</Typography>
                                </MenuItem>
                            )
                            }
                            {isAuthenticated && (

                                <MenuItem
                                    component="a"
                                    href={`${apiBaseUrl}/docs/InfoInteres.pdf?cacheBuster=${new Date().getTime()}`}

                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={handleCloseNavMenu}
                                >
                                    <Typography textAlign="center">Info adicional</Typography>
                                </MenuItem>
                            )
                            }
                            {isAuthenticated && (
                                <MenuItem onClick={logout} component={Link} to='/login'>
                                    <Typography textAlign="center">Cerrar Sesión</Typography>
                                </MenuItem>
                            )}
                            {!isAuthenticated && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/login">
                                    <Typography textAlign="center">Iniciar Sesión</Typography>
                                </MenuItem>
                            )}
                            {/* 
                            {!isAuthenticated && (
                                <MenuItem onClick={handleCloseNavMenu} component={Link} to="/register">
                                    <Typography textAlign="center">Registrarse</Typography>
                                </MenuItem>
                            )} */}
                        </Menu>
                    </Box>

                    {/* Botones en pantallas grandes */}
                    <Box sx={{ display: { xs: 'none', lg: 'flex' }, gap: 2 }}>

                        {isAdmin && (
                            <>
                                <Button color="inherit" component={Link} to="/novedades">Novedades</Button>
                                <Button color="inherit" component={Link} to="/calendar">Calendario</Button>
                                <Button color="inherit" component={Link} to="/reservas">Reservas</Button>
                                <Button color="inherit" component={Link} to="/admin">Gestion</Button>
                                <Button
                                    component="a"
                                    href={`${apiBaseUrl}/docs/Reglamento.pdf?cacheBuster=${new Date().getTime()}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="inherit"
                                >
                                    Reglamento
                                </Button>
                                <Button
                                    component="a"
                                    href={`${apiBaseUrl}/docs/InfoInteres.pdf?cacheBuster=${new Date().getTime()}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="inherit"
                                >
                                    Info adicional
                                </Button>
                                <Button color="inherit" onClick={logout}>Cerrar Sesión</Button>
                            </>

                        )}
                        {isAuthenticated && !isAdmin && (
                            <>
                                <Button color="inherit" component={Link} to="/novedades">Novedades</Button>
                                <Button color="inherit" component={Link} to="/calendar">Calendario</Button>
                                <Button color="inherit" component={Link} to="/profile">Mis reservas</Button>
                                <Button
                                    component="a"
                                    href={`${apiBaseUrl}/docs/InfoInteres.pdf?cacheBuster=${new Date().getTime()}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="inherit"
                                >
                                    Info adicional
                                </Button>
                                <Button
                                    component="a"
                                    href={`${apiBaseUrl}/docs/Reglamento.pdf?cacheBuster=${new Date().getTime()}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="inherit"
                                >
                                    Reglamento
                                </Button>
                                <Button color="inherit" onClick={logout}>Cerrar Sesión</Button>
                            </>
                        )}
                        {!isAuthenticated && (
                            <>
                                <Button color="inherit" component={Link} to="/login">Iniciar Sesión</Button>
                                {/* <Button color="inherit" component={Link} to="/register">Registrarse</Button> */}
                            </>
                        )}
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;